import * as actionType from "./actionTypes";

const INIT_STATE = {
  documentById: {},
  documentations: [],
  isLoading: false,
  error: false,
  errorMessage: "",
  success: false,
  successMessage: "",
};

const Documentations = (state = INIT_STATE, action) => {
  switch (action.type) {
    case actionType.SET_DOCUMENTATION_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case actionType.RESET_DOCUMENTATION_VARS:
      return {
        ...state,
        ...INIT_STATE,
      };
    case actionType.GET_ALL_DOCUMENTATIONS_SUCCESS:
      return {
        ...state,
        documentations: action.payload,
        isLoading: false,
        error: false,
        errorMessage: "",
        success: true,
      };
    case actionType.GET_ALL_DOCUMENTATIONS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: true,
        errorMessage: "Something went wrong",
        success: false,
        successMessage: "",
        documentations: [],
      };

    case actionType.GET_DOCUMENT_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: false,
        errorMessage: "",
        success: true,
        successMessage: "",
        documentById: action.payload,
      };
    case actionType.GET_DOCUMENT_BY_ID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: true,
        errorMessage: "Something went wrong",
        success: true,
        successMessage: "",
        documentById: action.payload,
      };

    case actionType.CREATE_DOCUMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: false,
        errorMessage: "",
        success: true,
        successMessage: "Note has been added successfully",
      };
    case actionType.CREATE_DOCUMENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: true,
        errorMessage: "Something went wrong",
        success: false,
        successMessage: "",
      };
    case actionType.UPDATE_DOCUMENT_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: false,
        errorMessage: "",
        success: true,
        successMessage: "Note has been updated successfully",
      };
    case actionType.UPDATE_DOCUMENT_BY_ID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: true,
        errorMessage: "Something went wrong, could not update the Note",
        success: false,
        successMessage: "",
      };
    case actionType.DELETE_DOCUMENT_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: false,
        errorMessage: "",
        success: true,
        successMessage: "Note has been deleted successfully",
      };
    case actionType.DELETE_DOCUMENT_BY_ID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: true,
        errorMessage: "Something went wrong, could not delete the Note",
        success: false,
        successMessage: "",
      };
    case actionType.EXPORT_DOCUMENTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: false,
        errorMessage: "",
        success: true,
        successMessage: "Note has been exported successfully",
      };
    case actionType.EXPORT_DOCUMENTS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: true,
        errorMessage: "Something went wrong, could not export the Notes",
        success: false,
        successMessage: "",
      };
    case actionType.IMPORT_DOCUMENTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: false,
        errorMessage: "",
        success: true,
        successMessage: "Note has been imported successfully",
      };
    case actionType.IMPORT_DOCUMENTS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: true,
        errorMessage: "Something went wrong, could not import the Notes",
        success: false,
        successMessage: "",
      };
    default:
      return state;
  }
};

export default Documentations;
